import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Card, 
  CardContent, 
  Button,
  Stack,
  Chip
} from '@mui/material';
import { 
  CheckCircle as CheckIcon,
  TrendingUp as TrendingUpIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  Support as SupportIcon
} from '@mui/icons-material';

const features = [
  {
    icon: <CheckIcon />,
    title: 'Instant Quotes',
    description: 'Get accurate pricing in seconds with our advanced calculation system',
    benefits: ['No hidden fees', 'Transparent pricing', 'Binding estimates']
  },
  {
    icon: <SecurityIcon />,
    title: 'Fully Insured',
    description: 'All moving services include comprehensive insurance coverage',
    benefits: ['$1M+ coverage', 'Claims support', 'Peace of mind']
  },
  {
    icon: <SpeedIcon />,
    title: 'Fast & Reliable',
    description: 'Professional movers with proven track records',
    benefits: ['On-time service', 'Quality guarantee', 'Professional crews']
  },
  {
    icon: <SupportIcon />,
    title: '24/7 Support',
    description: 'Round-the-clock customer service for all your needs',
    benefits: ['Live chat', 'Phone support', 'Email assistance']
  }
];

const WhyChooseUsSection = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={8}>
          <Typography
            variant="h2"
            fontWeight={700}
            mb={3}
            sx={{ fontSize: { xs: '2rem', md: '3rem' } }}
          >
            Why Choose Movd?
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ maxWidth: 600, mx: 'auto', lineHeight: 1.6 }}
          >
            We've revolutionized the moving industry with technology, transparency, and trust
          </Typography>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' }, gap: 4 }}>
          {features.map((feature, index) => (
            <Box key={index}>
              <Card
                sx={{
                  height: '100%',
                  p: 3,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 3,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderColor: 'primary.main',
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Box
                    sx={{
                      color: 'primary.main',
                      mb: 2,
                      fontSize: 40,
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    {feature.icon}
                  </Box>
                  
                  <Typography variant="h6" fontWeight={700} mb={2} textAlign="center">
                    {feature.title}
                  </Typography>
                  
                  <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    mb={3}
                    textAlign="center"
                    sx={{ lineHeight: 1.6 }}
                  >
                    {feature.description}
                  </Typography>

                  <Stack spacing={1}>
                    {feature.benefits.map((benefit, idx) => (
                      <Chip
                        key={idx}
                        label={benefit}
                        size="small"
                        variant="outlined"
                        sx={{
                          fontSize: '0.75rem',
                          height: 24,
                          borderColor: 'primary.main',
                          color: 'primary.main'
                        }}
                      />
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>

        <Box textAlign="center" mt={6}>
          <Button
            variant="outlined"
            size="large"
            sx={{
              px: 4,
              py: 1.5,
              fontWeight: 600,
              borderRadius: 2
            }}
          >
            Learn More About Our Services
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default WhyChooseUsSection;
